import React from 'react';
import { handlAuthSelectedBusiness } from '../reducersAndActions/actions/authAction';
import useLocalStorage from './useLocalStorage';
import { useAuth } from '../contexts/auth';

function useSelectedBusiness() {
  const [authState, authDispatch] = useAuth();
  const { selectedBusiness, allBusinesses } = authState;
  const queryParams = new URLSearchParams(window.location.search);
  const urlDocId = queryParams.get('docid') || '';
  const [selectedBusinessLocal, setSelectedBusinessLocal] = useLocalStorage('selectedBusiness', {});

  const setSelectedBusinessState = (doc = {}) => {
    handlAuthSelectedBusiness(authDispatch, doc);
  };

  const checkAndSetSelectedBusiness = () => {
    if (urlDocId && urlDocId !== '' && (!selectedBusiness || !selectedBusiness.docid)) {
      const filter = allBusinesses.filter((e) => e.docid === urlDocId);
      if (filter.length > 0 && urlDocId !== '') {
        setSelectedBusinessState(filter[0]);
      }
    } else if (!selectedBusiness || !selectedBusiness.docid) {
      if (selectedBusinessLocal && selectedBusinessLocal.docid) {
        setSelectedBusinessState(selectedBusinessLocal);
      } else if (allBusinesses.length) {
        setSelectedBusinessState(allBusinesses[0]);
      }
    }
  };

  React.useEffect(() => {
    checkAndSetSelectedBusiness();
  }, [allBusinesses]);

  React.useEffect(() => {
    setSelectedBusinessLocal(selectedBusiness);
  }, [selectedBusiness]);

  return { checkAndSetSelectedBusiness, setSelectedBusinessState };
}

export default useSelectedBusiness;
